export default function (props: any) {
    return (
        <svg width="6" height="11" viewBox="0 0 6 11" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M.45 9.692 4.692 5.45.45 1.207"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
